module.exports = __webpack_public_path__ + "img/sea.9c47ee6b.png";